import React from 'react';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/shared/Spinner';
import * as styles from './index.module.scss';

export const Loading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Spinner />
      <div className={styles.label}>{t('ui.expression.loading')}</div>
    </div>
  );
};
